import React from "react";
import styles from "styles/pages/HeatMapList.module.scss";
import { Tooltip, Button } from "@mui/material";

// Resolution action buttons. Availability is read from the CourseList response
// per resolution: 1meterElevationAvailable (1m), 3metersElevationAvailable (3m),
// and elevationAvailable (the legacy/10m flag). A button is disabled when its
// flag is not 1.
const RESOLUTIONS = [
	{ step: 1, label: "1m", availableKey: "1meterElevationAvailable" },
	{ step: 3, label: "3m", availableKey: "3metersElevationAvailable" },
	{ step: 10, label: "10m", availableKey: "elevationAvailable" },
];

const HeatMapListTableRowItem = ({ course, onResolutionClick }) => {
	const isInactive = course.active === 0;
	const rowStyle = isInactive ? { color: "red" } : {};

	return (
		<tr key={course.id_course} id={String(course.id_courseInt)}>
			<td className={styles.name_cont} style={rowStyle}>
				{course.id_courseInt}
			</td>
			<td className={styles.name_cont} style={rowStyle}>
				{course.courseName}
				<div className={styles.city_box} style={rowStyle}>
					<p>
						{course.city || "-"}, {course.stateShort || "-"}
					</p>
				</div>
			</td>
			<td className={styles.city_cont} style={rowStyle}>
				{course.city}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.stateShort || "--"}
			</td>
			<td className={styles.country_cont} style={rowStyle}>
				{course.countryFull}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.id_course}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.layoutHoles}
			</td>
			<td className={styles.one_meter_cont} style={rowStyle}>
				{course["1meterElevationAvailable"] === 1
					? "Yes"
					: course["1meterElevationAvailable"] === 0
					? "No"
					: "--"}
			</td>
			<td className={styles.state_cont} style={rowStyle}>
				{course.greenHeatmapAvailable}
			</td>
			<td className={styles.action_cont}>
				<div className={styles.action_bar}>
					{RESOLUTIONS.map(({ step, label, availableKey }) => {
						// Only disable when the flag is explicitly 0. If the field is
						// absent (e.g. a row from CourseDetails via ID search, which omits
						// these flags), leave the button enabled and let the fetch decide.
						const unavailable = course[availableKey] === 0;
						const title = unavailable
							? `${label} terrain not available for this course`
							: `Open ${label} terrain`;
						return (
							<Tooltip key={step} title={title} arrow placement="top">
								<span>
									<Button
										size="small"
										variant="outlined"
										disabled={unavailable}
										onClick={() => onResolutionClick(course, step)}
										sx={
											unavailable
												? undefined
												: {
														color: "var(--blue)",
														borderColor: "var(--blue)",
														"&:hover": { borderColor: "var(--blue)" },
												  }
										}
									>
										{label}
									</Button>
								</span>
							</Tooltip>
						);
					})}
				</div>
			</td>
		</tr>
	);
};

export default HeatMapListTableRowItem;
